module.exports = __webpack_public_path__ + "static/Hind-Bold-25ba4ea71ae01575b854681c42c1d0ef.ttf";